"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ACTION_BUTTON_SAVE = exports.ACTION_BUTTON_CANCEL = void 0;
const ACTION_BUTTON_CANCEL = exports.ACTION_BUTTON_CANCEL = 'action-button-cancel';
const ACTION_BUTTON_SAVE = exports.ACTION_BUTTON_SAVE = 'action-button-save';
